export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/spearmint-flavor.b5ab7d3a919e25f2afa45504ef4550ea.png";